import { IAssetResponse } from "./assets";

export enum ActivityType {
  INITIALISATION = "initialisation",
  PAGE_RECOGNITION = "page_recognition",
  LLM_REQUEST = "llm_request",
  PRODUCT_SEARCH = "product_search",
  SELECT_PRODUCT = "select_product",
  NAVIGATE_TO_PRODUCT = "navigate_to_product",
  SELECT_SKU = "select_sku",
  ADD_TO_CART = "add_to_cart",
  NAVIGATE_TO_CART = "navigate_to_cart",
  NAVIGATE_TO_CHECKOUT = "navigate_to_checkout",
  COUPON_APPLICATION_STARTED = "coupon_application_started",
  COUPON_APPLYING = "coupon_applying",
  COUPON_EVALUATING = "coupon_evaluating",
  COUPON_APPLICATION_ENDED = "coupon_application_ended",
  HUMAN_INTERVENTION_REQUESTED = "human_intervention_requested",
  POPUP_HANDLING = "popup_handling",
  SESSION_RESTORE = "session_restore",
  AUTO_COUPONS_ENGINE = "auto_coupons_engine",
  COMPLETED = "completed",
  NEW_MERCHANT = "new_merchant",
  WOO_COMMERCE = "woo_commerce",
  BIG_COMMERCE = "big_commerce",
  SHOPIFY = "shopify",
  MAGENTO = "magento",
  SALESFORCE = "salesforce",
}

export enum ActivityLogLevel {
  DEBUG = "debug",
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
}
export interface IActivityLog {
  level: ActivityLogLevel;
  message: string;
  timestamp: Date;
  metadata?: any;
}

export interface ITaskActivitySimple {
  _id: string;
  logs: IActivityLog[];
  llmCost?: number;
  type: ActivityType;
  metadata: any;
  screenshots: IAssetResponse[];
}

/** Returned by GET /tasks/:taskId/activities — no logs payload, just counts */
export interface ITaskActivitySummary {
  _id: string;
  type: ActivityType;
  llmCost?: number;
  metadata: any;
  screenshots: IAssetResponse[];
  warningCount: number;
  errorCount: number;
}
